<template>
  <div class="story-news-list">
    <ul class="person-story" v-if="currentIndex === 1">
      <li
        @click="cbDetail(item)"
        v-for="(item, index) in list" :key="index"
        class="slot-right __flex __flex-vc __bc-f"
      >
        <div class="img-contain" v-if="item.listImg">
          <van-image
            class="news-img"
            :src="formatAliyunPath(item.listImg)"
          />
        </div>
        <div class="content __flex __flex-cb">
          <div class="title __line1">
            <p class="__fs-17">{{item.title}}</p>
            <span v-for="jtem in item.tagList" :key="jtem.id" class="__fs-10">{{jtem.labelName}}</span>
          </div>
          <p class="summary __ellipsis __line2 __cor-8">{{item.summary}}</p>
        </div>
      </li>
    </ul>
    <common-steps v-else :list="list" @cb-detail="cbDetail">
    </common-steps>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
import CommonSteps from './common-steps'
export default {
  name: 'NewsList',
  components: {
    'common-steps': CommonSteps
  },
  props: {
    list: {
      type: Array
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cbDetail (item) {
      // this.$router.push({ path: '/news/detail' })
      this.$emit('cb-detail', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.story-news-list {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .person-story {
    margin-top: 20px;
    li {
      margin-bottom: 20px;
      width:  335px;
      padding: 0 15px;
      height: 88px;
      box-sizing: border-box;
      .img-contain {
        width: 83px;
        height: 62px;
        overflow: hidden;
        margin-right: 10px;
        .news-img {
          width: 100%;
          height: auto;
        }
      }
      .content {
        flex-direction: column;
        justify-content: space-between;
        height: 62px;
        .title {
          margin-right: 4px;
          display: flex;
          align-items: center;
          span {
            background-color: #E50914;
            color: #fff;
            padding: 2px 5px;
            margin-left: 8px;
            border-radius: 1px;
          }
        }
        .summary{
          // text-align: left;
        }
      }
    }
  }
}
</style>
